




























































import Vue from 'vue'
import { mapGetters } from 'vuex'
export default Vue.extend({
    computed: {
        ...mapGetters(['authIsAdmin']),
        content() {
            return {
                can_migrate_to_v2: {
                    title: 'Inbox by MessageDesk',
                    description: 
                        'A shared team SMS/MMS platform designed to ' +
                        'centralize all text-based communication across ' +
                        'your business phone numbers.',
                    sections: [
                        {
                            title: "Team Collaboration",
                            bullets: [
                                "Ability to assign multiple teammates to a conversation",
                                "Enhanced user permissions to control access to the inbox",
                                "Ability to mention teammates and use emoji reactions for quick coordination"
                            ]
                        },
                        {
                            title: "Organization & Management",
                            bullets: [
                                "Connect multiple phone numbers to one " +
                                    "inbox (up to 48 phone lines)",
                                "Label conversations for easy " +
                                    "categorization and filtering",
                                "Filter and sort by status, assignee, " +
                                    "phone line, or label",
                            ]
                        },
                        {
                            title: "Messaging Features",
                            bullets: [
                                "Unlimited 1:1 messaging, no longer worry about message credits",
                                "Send 1:1 messages, group messages (up to " +
                                    "7 contacts), or broadcasts (up to 100)",
                                "Send and receive media attachments " +
                                    "(images, PDFs, GIFs, and more)"
                            ]
                        },
                        {
                            title: "Automation & Access",
                            bullets: [
                                "Relays: automation rules for auto-assign, " +
                                    "auto-label, and autoresponders",
                                "Improved mobile app experience with new features and native support",
                                "Roles & permissions for granular access " +
                                    "control",
                            ]
                        }
                    ],
                }
            }
        }
    },
    methods: {
        //  Opens new window that takes user to the Inbox product page
        learnMore(): void {
            window.open(
                'https://www.messagedesk.com/features/team-inbox',
                this.$store.getters.isApp ? '_system' : '_blank'
            )
        }
    }
})
